/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import './add';
import './atan2';
import './avg_pool';
import './batchnorm';
import './broadcast_to';
import './batch_to_space_nd';
import './concat';
import './conv1d';
import './conv2d';
import './conv2d_transpose';
import './cumsum';
import './depth_to_space';
import './depthwise_conv2d';
import './depthwise_conv2D_deprecated';
import './div';
import './div_no_nan';
import './dot';
import './elu';
import './equal';
import './floorDiv';
import './greater';
import './greater_equal';
import './leaky_relu';
import './less';
import './less_equal';
import './local_response_normalization';
import './mat_mul';
import './max';
import './max_pool';
import './maximum';
import './minimum';
import './mod';
import './mul';
import './not_equal';
import './one_hot';
import './pad';
import './pool';
import './pow';
import './prelu';
import './relu';
import './relu6';
import './selu';
import './separable_conv2d';
import './split';
import './squared_difference';
import './space_to_batch_nd';
import './sub';
import './tile';
import './transpose';
